import { render, staticRenderFns } from "./segmentsSelect.vue?vue&type=template&id=4a98a643&"
import script from "./segmentsSelect.vue?vue&type=script&lang=js&"
export * from "./segmentsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports